module.exports = "/images/favicon.png?ec6da6694a660cb273d99f3a29358c72";